import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = { class: "card-header text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Admin", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("LTE")
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "login-box-msg" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "mt-3 mb-1" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "h1"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("messages.recoverYourPasswordNow")), 1),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.recoverPassword && _ctx.recoverPassword(...args)), ["prevent"]))
        }, [
          _createVNode(_component_app_input, {
            icon: "lock",
            class: "mb-3",
            type: "password",
            placeholder: "Password",
            autocomplete: "off",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.password) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_app_input, {
            icon: "lock",
            class: "mb-3",
            type: "password",
            placeholder: "Confirm password",
            autocomplete: "off",
            modelValue: _ctx.confirmPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.confirmPassword) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_app_button, {
                class: "btn-primary",
                type: "submit",
                block: "true"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.signIn")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 32),
        _createElementVNode("p", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/login",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("labels.login")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}